import axios from "axios";
import ConstantList from "../../../appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/patient-transfer";

export const confirmTransfer = (obj) => {
  var url = API_PATH + "/confirmTransfer";
  return axios.post(url, obj);
};

export const confirmTransferEtb = (obj) => {
  var url = API_PATH + "/confirm-transfer-etb";
  return axios.post(url, obj);
};

export const patientTransferOutByEncounter = (encounterId) => {
  var url = API_PATH + "/patient-transfer-out-by-encounter/" + encounterId;
  return axios.get(url);
};

export const getPageEtb = (obj) => {
  var url = API_PATH + "/getPageEtb";
  return axios.post(url, obj);
};

export const exportPatientTransferIn = (obj) => {
  let url = ConstantList.API_ENPOINT + "/api/etb/download-file/export-patient-in";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
}

export const exportPatientTransferOut = (obj) => {
  let url = ConstantList.API_ENPOINT + "/api/etb/download-file/export-patient-out";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
}

export const getViewPatientTransfer = (obj) => {
  var url = API_PATH + "/getViewPatientTransfer";
  return axios.post(url, obj);
};